import { styled } from '@mui/material/styles';
import MuiButton from '@mui/material/Button';

export const MainContainedBtn = styled(MuiButton)(({ theme: { // @ts-ignore
    palette: { containedButton }, breakpoints } }) => ({
  color: containedButton.main.color,
  width: '100%',
  backgroundColor: containedButton.main.bgDefault,
  borderColor: containedButton.main.bgDefault,
  boxShadow: 'none',
  fontSize: '18px',
  fontWeight: '800',

  [breakpoints.down('md')]: {
    fontSize: '16px',
    fontWeight: '700'
  },

  '&:hover': {
    boxShadow: 'none',
    color: containedButton.main.color,
    backgroundColor: containedButton.main.bgHover,
    borderColor: containedButton.main.bgHover
  },
  '&:active': {
    boxShadow: 'none',
    color: containedButton.main.color,
    backgroundColor: containedButton.main.bgActive,
    borderColor: containedButton.main.bgActive
  },
  '&:disabled': {
    boxShadow: 'none',
    color: containedButton.main.color,
    backgroundColor: containedButton.main.bgDisabled,
    borderColor: containedButton.main.bgDisabled
  }
}));

export const MainTextBtn = styled(MuiButton)(({ theme: { // @ts-ignore
    palette: { containedButton }, breakpoints } }) => ({
  color: containedButton.main.color,
  width: '100%',
  // backgroundColor: containedButton.main.bgDefault,
  // borderColor: containedButton.main.bgDefault,
  boxShadow: 'none',
  fontSize: '18px',
  fontWeight: '800',

  [breakpoints.down('md')]: {
    fontSize: '16px',
    fontWeight: '700'
  },

  '&:hover': {
    boxShadow: 'none',
    color: containedButton.main.color
    // backgroundColor: containedButton.main.bgHover,
    // borderColor: containedButton.main.bgHover
  },
  '&:active': {
    boxShadow: 'none',
    color: containedButton.main.color
    // backgroundColor: containedButton.main.bgActive,
    // borderColor: containedButton.main.bgActive
  },
  '&:disabled': {
    boxShadow: 'none',
    color: containedButton.main.color
    // backgroundColor: containedButton.main.bgDisabled,
    // borderColor: containedButton.main.bgDisabled
  }
}));
